// extracted by mini-css-extract-plugin
export var button = "_kc-2";
export var card = "_kc-0";
export var closeButtonContainer = "_kc-3";
export var iconContainer = "_kc-1";